// Binary data frames (format validated by spike S3):
// [u8 type=1][u8 flags (bit0 = sha256 present)][u16 reserved][u32 seq][f64 offset][32 B sha256?][payload]

export const HEADER = 16;
export const DIGEST = 32;

export async function encodeFrame(seq: number, offset: number, payload: Uint8Array<ArrayBuffer>, withHash = true): Promise<ArrayBuffer> {
  const extra = withHash ? DIGEST : 0;
  const buf = new ArrayBuffer(HEADER + extra + payload.byteLength);
  const view = new DataView(buf);
  view.setUint8(0, 1);
  view.setUint8(1, withHash ? 1 : 0);
  view.setUint32(4, seq);
  view.setFloat64(8, offset);
  const bytes = new Uint8Array(buf);
  if (withHash) bytes.set(new Uint8Array(await crypto.subtle.digest('SHA-256', payload)), HEADER);
  bytes.set(payload, HEADER + extra);
  return buf;
}

export type Frame = { seq: number; offset: number; payload: Uint8Array<ArrayBuffer>; hashOk: boolean | null };

export async function decodeFrame(buf: ArrayBuffer): Promise<Frame> {
  if (buf.byteLength < HEADER) throw new Error('short frame');
  const view = new DataView(buf);
  if (view.getUint8(0) !== 1) throw new Error('unknown frame type');
  const hashed = (view.getUint8(1) & 1) === 1;
  const start = HEADER + (hashed ? DIGEST : 0);
  if (buf.byteLength < start) throw new Error('short frame');
  const payload = new Uint8Array(buf, start);
  let hashOk: boolean | null = null;
  if (hashed) {
    const got = new Uint8Array(await crypto.subtle.digest('SHA-256', payload));
    const want = new Uint8Array(buf, HEADER, DIGEST);
    hashOk = got.every((b, i) => b === want[i]);
  }
  return { seq: view.getUint32(4), offset: view.getFloat64(8), payload, hashOk };
}
